@if (deprecatedDomainUrl) {
    <div class="deprecated-domain-overlay" role="alertdialog" aria-modal="true">
        <div class="deprecated-domain-overlay__box">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="deprecated-domain-overlay__icon" aria-hidden="true">
                <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.5-34.7-19.8s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/>
            </svg>
            <h2 class="deprecated-domain-overlay__title">This domain is deprecated</h2>
            <p class="deprecated-domain-overlay__message">
                <strong>{{ deprecatedHostname }}</strong> is no longer supported.<br>
                Please update your bookmarks and go to the new address to continue:
            </p>
            <a [href]="deprecatedDomainUrl" class="deprecated-domain-overlay__link">
                {{ deprecatedDomainUrl }}
            </a>
        </div>
    </div>
}
@if (isLoading()) {
    <app-loading></app-loading>
} @else {
    <p-toast></p-toast>
    <p-confirmDialog key="confirm" />
    <router-outlet></router-outlet>
}
@if (isDebug) {
    <app-debug-fab></app-debug-fab>
}
